import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    pattern: String
  }

  connect() {
    this.format = this.format.bind(this)
    this.element.addEventListener("input", this.format)
    // Format initial value
    if (this.element.value) {
      this.format()
    }
  }

  disconnect() {
    this.element.removeEventListener("input", this.format)
  }

  format() {
    const input = this.element
    // Remove all non-alphanumeric characters
    let value = input.value.toUpperCase().replace(/[^0-9A-Z]/g, "")
    
    // Apply mask: xxxxxx-xxxx
    if (value.length > 6) {
      value = value.slice(0, 6) + "-" + value.slice(6)
    }
    
    // Limit length to 11 characters (6 + 1 + 4)
    if (value.length > 11) {
      value = value.slice(0, 11)
    }
    
    // Only update if value changed to avoid cursor jumping when not needed
    if (input.value !== value) {
      input.value = value
    }
  }
}

